<template>
  <a href="#" class="logo">
    <span class="logo-mini"><b>custom</b></span>
    <span class="logo-lg"><b>custom客服系统</b></span>
  </a>
</template>

<script>
export default {
  name: 'AltLogo'
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/AltLogo.vue